export default __webpack_public_path__ + "static/media/lux-register-no-bg.34483d40.png";